import getEnv from '@/shared/configs/env';
import { createAxiosClient } from './createAxiosClient';

export const client = createAxiosClient({
  options: {
    baseURL: getEnv().backend,
    timeout: 300000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
});

export const modernClient = createAxiosClient({
  options: {
    baseURL: getEnv().modern_backend,
    timeout: 300000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
});
